import { useCallback } from 'react';
import LogRocket from 'logrocket';

import type { FreightProviderTrackingSlug } from './use-track-freight-connect-existing-clicked';

const logRocketFreightConnectFailedEventName = 'FREIGHT_CONNECT_FAILED';

export const useTrackFreightConnectFailed = (): ((provider: FreightProviderTrackingSlug, reason: string) => void) => {
  return useCallback((provider: FreightProviderTrackingSlug, reason: string) => {
    const environment = process.env.NODE_ENV ?? 'development';
    LogRocket.track(logRocketFreightConnectFailedEventName, { env: environment, provider, reason });
  }, []);
};
